import moment from 'moment';

import { fetchFromOldApi } from '~/services/Http';

export const revalidateNotificationsInterval = 60 * 1000;

export const markAllAsRead = () => {
  const now = moment().format('YYYY-MM-DDTHH:mm:ssZZ');
  return fetchFromOldApi(
    `/json/user/notification?beforeTime=${now}`.replace('+', '%2B'),
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
    },
  ).then((r) => r.json());
};

export const deleteAll = () => {
  const now = moment().format('YYYY-MM-DDTHH:mm:ssZZ');
  return fetchFromOldApi(
    `/json/user/notification?beforeTime=${now}`.replace('+', '%2B'),
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
  ).then((r) => r.json());
};

export const deleteNotification = (id: string | number) => {
  return fetchFromOldApi(`/json/user/notification/${id}`, {
    method: 'DELETE',
  }).then((r) => r.json());
};

export const unreadNotification = (id: string | number) => {
  return fetchFromOldApi(`/json/user/notification/${id}?isRead=false`, {
    method: 'PUT',
  }).then((r) => r.json());
};

export const readNotification = (id: string | number) => {
  return fetchFromOldApi(`/json/user/notification/${id}?isRead=true`, {
    method: 'PUT',
  }).then((r) => r.json());
};
